import React from 'react';
import Widget from "../../prefabricated/Widget";
import {BRCustomizedTooltip as Tooltip} from "../accents/BRCustomizedTooltip";
import {Badge, Col, Row} from "reactstrap";
import {
    bbDangerousStringToDate,
    bbDoesCustomerHaveAccessToSubscription,
    bbFormattedDateString,
    isCurrentUserMemberOf
} from "../../../util/bbHelpers";
import {useSelector} from "react-redux";




const BRSubscriptionWidget = ({customer=null,}) => {

    const {authUser} = useSelector(({auth})=> auth);
    const {customers, customerInView} = useSelector(({customer})=> customer);

    // const dispatch = useDispatch();

    // const isStaffAdmin = isCurrentUserMemberOf(authUser, "admin") || isCurrentUserMemberOf(authUser, "staff");
    const customerSubs = customer && customer.Subscriptions && Object.values(customer.Subscriptions);

    const brBizSub = customerSubs.filter((sub)=> sub.subscription_type && sub.subscription_type.id === 2);
    const hasBRBusiness = brBizSub && brBizSub.length > 0;
    // const brBizIsActive = bbDoesCustomerHaveAccessToSubscription(customer, 2)
    const brBizSubLevel = hasBRBusiness && brBizSub[0] && brBizSub[0].subscription_level;
    // const brBizSubLevelDescription = brBizSubLevel && brBizSubLevel.description;
    // const brBizSubLevelName = brBizSubLevel && brBizSubLevel.name;

    const brPortSub = customerSubs.filter((sub)=> sub.subscription_type.id === 1);
    const hasBRPort = brPortSub && brPortSub.length > 0;
    // const brPortIsActive = bbDoesCustomerHaveAccessToSubscription(customer, 1);
    const brPortSubLevel = hasBRPort && brPortSub[0] && brPortSub[0].subscription_level;
    // const brPortSubLevelDescription = brPortSubLevel && brPortSubLevel.description;
    // const brPortSubLevelName = brPortSubLevel && brPortSubLevel.name;

    // if(customerSubs.length !== 0 && customer) {

    // const handleClick =()=>{
    //     dispatch(fetchSubscription({
    //         customerId: customerInView
    //     }));
    //
    // }

    // console.log("Look at manager status--authUser", authUser, "authUserCUstomerArray", authUserCustomerArray, "userCustomerObjectInView", userCustomerObjectInView
    //     , "authUserIsmanager", authUserIsManager );

    return (
        <Row>

            {customerSubs && customerSubs.length > 0
                ? customerSubs.map((sub, index)=>
                    <Col key={index}>
                        <Widget styleName={`p-2 text-center `} >

                            <div className={"row"}>
                                <div className={"col-12"}>
                                    <h2>
                                        {sub.subscription_type && sub.subscription_type.name}
                                        &nbsp;
                                        {(sub.is_active && (!sub.subscription_end || (sub.subscription_end && bbDangerousStringToDate(sub.subscription_end) > Date.now())))
                                            ? <Tooltip title={sub && sub.subscription_level && sub.subscription_level.description}>
                                        <span>&nbsp;
                                            <Badge
                                                color={"electric-blue-light"}>
                                                    {sub && sub.subscription_level && sub.subscription_level.name}
                                                </Badge>
                                        </span>
                                            </Tooltip>
                                            :
                                            <span>
                                        <Badge
                                            color={'grey'}>
                                        {sub && sub.subscription_level && sub.subscription_level.name}
                                    </Badge>
                                        <small><em>Inactive</em></small>
                                    </span>
                                        }

                                    </h2>
                                </div>
                            </div>

                            {/*<SubscriptionStatusAndControlWidget customerId={customer.CustomerId} subId={hasBRBusiness ? brBizSub[0].id : null} showControls={isStaffAdmin}/>*/}

                            <div className={"row"}>
                                <div className={"col-12 mt-1"}>
                                    {/*<small><em>Since {bbFormattedDateString(sub.subscription_start, "short")} {sub.customer_provided ? `provided by ${sub.customer_provided}` : ""}</em></small>*/}
                                    <p>{sub && sub.subscription_level && sub.subscription_level.description}</p>
                                </div>
                            </div>
                            <div className={"row d-inline mb-1"}>
                                <div className={"col-6 d-inline"}>
                                    <strong> Start: </strong>
                                    {sub.subscription_start ? bbFormattedDateString(sub.subscription_start, 'short') : "--"}
                                </div>
                                <div className={"col-6 d-inline"}>
                                    <strong> End: </strong>
                                    {sub.subscription_end ? bbFormattedDateString(sub.subscription_end, 'short') : "--"}
                                </div>
                            </div>

                            {(sub.customer_provided && customers[sub.customer_provided]) &&
                                <div className={"row m-0"}>
                                    <Tooltip title={`BreachRisk subscription provided by ${customers[sub.customer_provided].CustomerName} as your company is a part of their portfolio.`}>
                                        <div className={"col-12 m-0"}>
                                            <em>Provided By: {customers[sub.customer_provided].CustomerName}</em>
                                        </div>
                                    </Tooltip>
                                </div>}

                        </Widget>
                    </Col>


            )
            :
                <Widget styleName={`p-2 text-center`}>
                    <div className={"row"}>
                        <div className={"col-12"}>
                            <h2>
                                BreachRisk
                                &nbsp;
                                    <Badge
                                        color={'grey'}>
                                        Inactive
                                    </Badge>
                            </h2>
                        </div>
                    </div>

                    <div className={"row"}>
                        <div className={"col-12 mt-1"}>
                            <p></p>
                        </div>
                    </div>
                    <div className={"row d-inline mb-1"}>
                        <div className={"col-6 d-inline"}><strong> Start: </strong> -- </div>
                        <div className={"col-6 d-inline"}><strong> End: </strong> -- </div>
                    </div>
                </Widget>
            }
        </Row>
    )
}

export default BRSubscriptionWidget;